/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type Tile_item = {
    readonly isCustomizable: boolean | null;
    readonly isMultiSku: boolean;
    readonly serviceId: string | null;
    readonly localizedPdpUrl: string | null;
    readonly title: string | null;
    readonly vertical: VerticalType | null;
    readonly seller?: {
        readonly serviceId: string | null;
        readonly " $fragmentRefs": FragmentRefs<"Info_seller">;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"Info_item" | "Product_item" | "QuickViewItem_item">;
    readonly " $refType": "Tile_item";
};
export type Tile_item$data = Tile_item;
export type Tile_item$key = {
    readonly " $data"?: Tile_item$data;
    readonly " $fragmentRefs": FragmentRefs<"Tile_item">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "Tile_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "isTrade",
      "type": "Boolean",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "showSeller",
      "type": "Boolean",
      "defaultValue": false
    },
    {
      "kind": "LocalArgument",
      "name": "showPrice",
      "type": "Boolean",
      "defaultValue": true
    },
    {
      "kind": "LocalArgument",
      "name": "pageDisplayEnum",
      "type": "PageDisplayEnum",
      "defaultValue": "searchAndBrowse"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isCustomizable",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isMultiSku",
      "args": null,
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "localizedPdpUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "vertical",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "Info_item",
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "pageDisplayEnum",
          "variableName": "pageDisplayEnum"
        },
        {
          "kind": "Variable",
          "name": "showPrice",
          "variableName": "showPrice"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "Product_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "QuickViewItem_item",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "showSeller",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "seller",
          "storageKey": null,
          "args": null,
          "concreteType": "Seller",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "FragmentSpread",
              "name": "Info_seller",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = '789578c9f8cd7cb98b133630c359a872';
export default node;
